import React from "react";
import Page from "../../common/page/Page.js";
import CandidatesBlock from "./CandidatesBlock.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import useAuthUser from "../../authentication-no-ui/useAuthUser.js";
import useTranslationCandidates from "../useTranslationCandidates.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";

export default function CandidatesPage(props) {
  const { profile: recruiter } = useAuthUser();
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="CandidatesPage">
          <Page.Title
            text={t("candidates:candidates_page_title")}
            loading={tLoading}
          />
          <Page.Content>
            <CandidatesBlock recruiterId={recruiter._id} />
          </Page.Content>
        </Page>
      )}
    />
  );
}
